import { createSlice } from "@reduxjs/toolkit";
import { STATES_NAMES, USER_TYPES } from "../../enums/Enums";
import { getSiteFromSiteId, getUserTypeFromUserTypeId } from "../../utils/UsersUtils";
import { getCommonTokens } from "../../utils/AllocationUtils";

const allocationsInitialState = {
    allocations: [],
    commonTokens: [],
    allocationSelectionModel: null
}

const allocationsSlice = createSlice({
    name: STATES_NAMES.ALLOCATIONS,
    initialState: allocationsInitialState,
    reducers: {
        setAllocations(state, action) {
            // set here allocations after userIds call on useAllocationService
            let parkers = action.payload.parkers;
            let sites = action.payload.sites;
            let userTypes = action.payload.userTypes;
            
            if (parkers?.length > 0) {
              let allocations = parkers.map((parker) => {
                // represents tokens that are assigned to cars - the token will contain a car for table usage
                // (without e ticket cars and Transients)
                let assignCarTokens = parker.utronUser.cars
                  .filter((car) => !car.isETicketCar)
                  .map((car) => {
                    // doin the check per car
                    // finds assignedCarToken to a car - (for every carUserToken finds to which car it belongs)
                    // occupied - associates to user
                    let assignCarTokens = parker.utronUser.carUserTokens.filter(
                      (carUserToken) =>
                        carUserToken.token.userTypeId !== USER_TYPES.TRANSIENT &&
                        !carUserToken.token.deleted
                    ); //.map(carUserToken => carUserToken.token);
          
                    // flip - arranges that car & parker will be inside carUserToken
                    assignCarTokens = assignCarTokens.map((assign) => {
                      // populate site with site obj
                      let assignCopy = { ...assign };
                      let assignTokenCopy = { ...assign.token };
                      let userType = getUserTypeFromUserTypeId(userTypes, assign.token.userTypeId);
                      let site = getSiteFromSiteId(sites, assign.token.siteId);

                      // populates site with site obj
                      assignTokenCopy.site = site;
                      assignCopy.token = assignTokenCopy;

                      // populates userType with userType obj
                      assignTokenCopy.userType = userType;
                      assignCopy.userType = assignTokenCopy;
          
                      assignCopy = { ...assignCopy, car };
                      assignCopy = { ...assignCopy, parker };
          
                      return assignCopy;
                    });
          
                    return assignCarTokens;
                  })
                  .flat();       

                // represents the user allocations - both assigned and non-assigned
                let userTokens = assignCarTokens; 
          
                return userTokens;
              })
              .flat()
            
            // distinct array
            allocations = allocations?.filter((item, index) => allocations?.findIndex((allocation) => item.id === allocation.id) === index);

            // set allocations
            state.allocations = allocations;
            
            // set common tokens
            state.commonTokens = getCommonTokens('tokenId', allocations, 1);
            }
            else {
              // reset if no parkers were founded
              state.allocations = [];
              state.commonTokens = [];
              state.allocationSelectionModel = null;
            }           
        },
        setCommonTokens(state, action) {
            state.commonTokens = action.payload;
        },
        updateAllocation(state, action) {
            let allocationToUpdate = action.payload;
            let foundedAllocationIndex = state.allocations.findIndex(allocation => allocation.id === allocationToUpdate.id);
            state.allocations[foundedAllocationIndex] = allocationToUpdate;
        },
        updateAllocationsFob(state, action) {
            let allocationsToUpdate = action.payload;
            let res = state.allocations.map(allocation => {
                let foundedAllocation = allocationsToUpdate.find(atu => allocation.id === atu.id);
                if (foundedAllocation !== undefined) {
                    let allocationCopy = {...allocation};
                    allocationCopy.fob = foundedAllocation.fob;
                    return allocationCopy;
                }
                return allocation;
            });
            
            state.allocations = res;
        },
        setAllocationSelectionModel(state, action) {
          state.allocationSelectionModel = action.payload;
        }
    }
});

export const allocationsActions = allocationsSlice.actions;

export default allocationsSlice.reducer;